/* Palsora header: pet menus, account card, sticky/slim on scroll, search drawer */
(function () {
  if (window.__palsHeader) return;
  window.__palsHeader = true;

  function initHeader(root) {
    var pets = root.querySelectorAll('[data-pals-pet]');
    var acctBtn = root.querySelector('[data-pals-acct]');
    var acct = root.querySelector('.pals-acct');
    var hoverable = window.matchMedia('(hover: hover) and (min-width: 750px)');
    var closeTimer;
    function panel(id) { return document.getElementById('PalsMega-' + id); }
    function closeAll(except) {
      pets.forEach(function (b) {
        if (b === except) return;
        b.setAttribute('aria-expanded', 'false');
        var p = panel(b.getAttribute('data-pals-pet')); if (p) p.classList.remove('is-open');
      });
      if (acct && acctBtn && except !== acctBtn) { acct.classList.remove('is-open'); acctBtn.setAttribute('aria-expanded', 'false'); }
    }
    function openPet(b) {
      clearTimeout(closeTimer);
      closeAll(b);
      b.setAttribute('aria-expanded', 'true');
      var p = panel(b.getAttribute('data-pals-pet')); if (p) p.classList.add('is-open');
    }
    function scheduleClose() { clearTimeout(closeTimer); closeTimer = setTimeout(function () { closeAll(null); }, 160); }
    pets.forEach(function (b) {
      var p = panel(b.getAttribute('data-pals-pet'));
      b.addEventListener('click', function () { b.getAttribute('aria-expanded') === 'true' ? closeAll(null) : openPet(b); });
      b.addEventListener('mouseenter', function () { if (hoverable.matches) openPet(b); });
      b.addEventListener('mouseleave', function () { if (hoverable.matches) scheduleClose(); });
      if (p) {
        p.addEventListener('mouseenter', function () { if (hoverable.matches) clearTimeout(closeTimer); });
        p.addEventListener('mouseleave', function () { if (hoverable.matches) scheduleClose(); });
      }
    });
    if (acctBtn && acct) {
      acctBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = !acct.classList.contains('is-open');
        closeAll(acctBtn);
        acct.classList.toggle('is-open', open);
        acctBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) closeAll(null); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });

    // sticky header: slim down after scrolling
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { root.classList.toggle('is-stuck', window.scrollY > 60); ticking = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    initSearch(root);
  }

  function initSearch(root) {
    var box = root.querySelector('.pals-srch');
    if (!box) return;
    var trigger = root.querySelector('[data-pals-search]');
    var dim = root.querySelector('.pals-srch__dim');
    var q = box.querySelector('.pals-srch__q');
    var idle = box.querySelector('.pals-srch__idle');
    var live = box.querySelector('.pals-srch__live');
    var list = box.querySelector('.pals-srch__res');
    var all = box.querySelector('.pals-srch__all');
    var clearBtn = box.querySelector('.pals-srch__clear');
    var recentWrap = box.querySelector('.pals-srch__recentwrap');
    var recentBox = box.querySelector('.pals-srch__recent');
    var searchUrl = root.getAttribute('data-search-url') || '/search';
    var predictUrl = root.getAttribute('data-predict-url') || '/search/suggest';
    var timer, ctrl, active = -1, KEY = 'palsRecentSearches';
    var esc = function (t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var getRecent = function () { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
    var saveRecent = function (term) {
      term = term.trim(); if (!term) return;
      var r = getRecent().filter(function (x) { return x.toLowerCase() !== term.toLowerCase(); });
      r.unshift(term); r = r.slice(0, 4);
      try { localStorage.setItem(KEY, JSON.stringify(r)); } catch (e) {}
    };
    var drawRecent = function () {
      var r = getRecent();
      if (!recentWrap) return;
      recentWrap.hidden = !r.length;
      recentBox.innerHTML = r.map(function (t) { return '<button type="button" data-q="' + esc(t) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>' + esc(t) + '</button>'; }).join('');
    };
    var open = function () { drawRecent(); box.classList.add('is-open'); dim.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); setTimeout(function () { q.focus(); }, 60); };
    var close = function () { box.classList.remove('is-open'); dim.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); q.setAttribute('aria-expanded', 'false'); };
    trigger.addEventListener('click', function (e) { e.preventDefault(); box.classList.contains('is-open') ? close() : open(); });
    box.querySelector('.pals-srch__close').addEventListener('click', function () { close(); trigger.focus(); });
    dim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.classList.contains('is-open')) { close(); trigger.focus(); return; }
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (e.key === '/' && !box.classList.contains('is-open') && !/INPUT|TEXTAREA|SELECT/.test(tag) && !(document.activeElement && document.activeElement.isContentEditable)) { e.preventDefault(); open(); }
    });
    var hl = function (text, term) {
      var i = text.toLowerCase().indexOf(term.toLowerCase());
      if (i < 0 || !term) return esc(text);
      return esc(text.slice(0, i)) + '<mark>' + esc(text.slice(i, i + term.length)) + '</mark>' + esc(text.slice(i + term.length));
    };
    var setActive = function (i) {
      var items = list.querySelectorAll('.pals-srch__item');
      active = Math.max(-1, Math.min(i, items.length - 1));
      items.forEach(function (el, n) { el.classList.toggle('is-active', n === active); el.setAttribute('aria-selected', n === active ? 'true' : 'false'); });
    };
    var render = function (term, products) {
      all.href = searchUrl + '?type=product&q=' + encodeURIComponent(term);
      all.firstChild.nodeValue = 'See all results for “' + term + '” ';
      active = -1;
      if (!products.length) { list.innerHTML = '<div class="pals-srch__none">No matches for “' + esc(term) + '” yet. Try another word, or browse a category.</div>'; return; }
      list.innerHTML = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        var price = p.price ? '$' + Number(p.price).toFixed(2) : '';
        return '<a class="pals-srch__item" role="option" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="56" height="56">' : '') + '<div><div class="pals-srch__n">' + hl(p.title, term) + '</div><div class="pals-srch__p">' + esc(price) + '</div></div><span class="pals-srch__go" aria-hidden="true">&rarr;</span></a>';
      }).join('');
    };
    var run = function () {
      var term = q.value.trim();
      clearBtn.hidden = !q.value;
      if (!term) { idle.hidden = false; live.hidden = true; q.setAttribute('aria-expanded', 'false'); drawRecent(); return; }
      idle.hidden = true; live.hidden = false; q.setAttribute('aria-expanded', 'true');
      if (!list.querySelector('.pals-srch__item')) list.innerHTML = '<div class="pals-srch__skel"></div>';
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        fetch(predictUrl + '.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6', ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (d) { render(term, (d.resources && d.resources.results && d.resources.results.products) || []); })
          .catch(function () {});
      }, 180);
    };
    q.addEventListener('input', run);
    q.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Enter') {
        saveRecent(q.value);
        var items = list.querySelectorAll('.pals-srch__item');
        if (active > -1 && items[active]) { e.preventDefault(); window.location.href = items[active].href; }
      }
    });
    list.addEventListener('click', function (e) { if (e.target.closest('.pals-srch__item')) saveRecent(q.value); });
    all.addEventListener('click', function () { saveRecent(q.value); });
    clearBtn.addEventListener('click', function () { q.value = ''; run(); q.focus(); });
    box.addEventListener('click', function (e) {
      var b = e.target.closest('.pals-srch__pop button');
      if (!b) return;
      q.value = b.getAttribute('data-q'); run(); q.focus();
    });
  }

  function boot() { document.querySelectorAll('[data-pals-header]').forEach(initHeader); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // re-initialise when the header is edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-pals-header]'); if (r) initHeader(r); });
})();
